// @flow
import { Link } from 'react-router-dom'
import React, { Component } from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/message.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/grid.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/card.css'

export type VotePreference = {
  velo: boolean | null,
  fairFood: boolean | null,
  ernaehrung: boolean | null
}

type Props = {
  handleVotePreferences: (votePreference: VotePreference) => void,
  municipalityId: number
}

type State = {
  votePreference: VotePreference
}

export class Questionnaire extends Component<Props, State> {
  state: State = {
    votePreference: {
      velo: null,
      fairFood: null,
      ernaehrung: null
    }
  }

  checkAllVotes: (preferences: Object) => boolean = preferences => {
    return Object.values(preferences).every(item => item !== null)
  }

  handleVote = (
    initiative: 'velo' | 'fairFood' | 'ernaehrung',
    vote: boolean
  ) => {
    this.setState((previousState, props) => {
      let votePreference = previousState.votePreference
      votePreference[initiative] =
        votePreference[initiative] === vote ? null : vote

      if (this.checkAllVotes(votePreference)) {
        this.props.handleVotePreferences(votePreference)
      }

      return {
        ...previousState,
        votePreference
      }
    })
  }

  passVotesUpwards = () => {
    this.props.handleVotePreferences(this.state.votePreference)
  }

  render () {
    return (
      <div className='step questionnaire'>
        <h2 className='ui header'>
          <div className='sub header'>Schritt 2</div>
          Wie haben Sie abgestimmt?
        </h2>

        <div className='ui icon message'>
          <i className='help circle icon' />
          <div className='content'>
            <p>
              Wenn Sie uns angeben, wie sie abgestimmt haben (oder hätten),
              können wir Ihren Text noch weiter individualisieren.
            </p>
            <p>
              Sie können auch{' '}
              <Link
                to={'/artikel/fuer/' + this.props.municipalityId}
                onClick={this.passVotesUpwards}
              >
                ohne diese Angabe fortfahren<i className='right angle icon' />
              </Link>
            </p>
          </div>
        </div>

        <div className='ui three doubling stackable cards'>
          <div className='card'>
            <div className='content'>
              <h4 className='header'>Gegenentwurf zur Velo-Initiative</h4>
              <div className='description'>
                Wollen Sie den Bundesbeschluss vom 13. März 2018 über die
                Velowege sowie die Fuss- und Wanderwege annehmen?
              </div>
            </div>
            <div className='ui bottom attached buttons'>
              <button
                onClick={() => this.handleVote('velo', false)}
                className={`ui negative ${
                  this.state.votePreference.velo === false ? '' : 'basic active'
                } button`}
              >
                Nein
              </button>
              <button
                onClick={() => this.handleVote('velo', true)}
                className={`ui positive ${
                  this.state.votePreference.velo === true ? '' : 'basic active'
                }  button`}
              >
                Ja
              </button>
            </div>
          </div>

          <div className='card'>
            <div className='content'>
              <h4 className='header'>Fair-Food-Initiative</h4>
              <div className='description'>
                Wollen Sie die Volksinitiative «Für gesunde sowie
                umweltfreundlich und fair hergestellte Lebensmittel
                (Fair-Food-Initiative)» annehmen?
              </div>
            </div>
            <div className='ui bottom attached buttons'>
              <button
                onClick={() => this.handleVote('fairFood', false)}
                className={`ui negative ${
                  this.state.votePreference.fairFood === false
                    ? ''
                    : 'basic active'
                } button`}
              >
                Nein
              </button>
              <button
                onClick={() => this.handleVote('fairFood', true)}
                className={`ui positive ${
                  this.state.votePreference.fairFood === true
                    ? ''
                    : 'basic active'
                } button`}
              >
                Ja
              </button>
            </div>
          </div>

          <div className='card'>
            <div className='content'>
              <h4 className='header'>Ernährungssouveränität</h4>
              <div className='description'>
                Wollen Sie die Volksinitiative «Für Ernährungssouveränität. Die
                Landwirtschaft betrifft uns alle» annehmen?
              </div>
            </div>
            <div className='ui bottom attached buttons'>
              <button
                onClick={() => this.handleVote('ernaehrung', false)}
                className={`ui negative ${
                  this.state.votePreference.ernaehrung === false
                    ? ''
                    : 'active basic'
                } button`}
              >
                Nein
              </button>
              <button
                onClick={() => this.handleVote('ernaehrung', true)}
                className={`ui positive ${
                  this.state.votePreference.ernaehrung === true
                    ? ''
                    : 'basic active'
                } button`}
              >
                Ja
              </button>
            </div>
          </div>
        </div>

        <div className='ui vertical right aligned segment'>
          <div className='ui large buttons mobile hidden'>
            <Link
              to={'/gemeindeauswahl'}
              className='ui basic labeled icon button'
            >
              <i className='left chevron icon' />
              Zurück
            </Link>
            <Link
              to={'/artikel/fuer/' + this.props.municipalityId}
              className='ui basic right labeled icon button'
              onClick={this.passVotesUpwards}
            >
              Ohne Angabe weiter zum Artikel{' '}
              <i className='right chevron icon' />
            </Link>
          </div>
          <div className='ui large vertical buttons mobile only'>
            <Link
              to={'/artikel/fuer/' + this.props.municipalityId}
              className='ui basic right labeled icon button'
              onClick={this.passVotesUpwards}
            >
              Ohne Angabe weiter zum Artikel{' '}
              <i className='right chevron icon' />
            </Link>

            <Link
              to={'/gemeindeauswahl'}
              className='ui basic labeled icon button'
            >
              <i className='left chevron icon' />
              Zurück
            </Link>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/questionnaire/index.js